import { client } from '@/client';

// 获取集群broker url
export function getClusterInfo(clusterName) {
  return client.get(`/api/resource/cluster/getClusterInfo?clusterName=${clusterName}`);
}

// 获取代码示例下载地址
export function getCodeExampleUrl() {
  return client.get(`/api/console/dictionary/getCodeExampleUrl`);
}
